import { render, staticRenderFns } from "./EditPopover.vue?vue&type=template&id=f0689786&scoped=true"
import script from "./EditPopover.vue?vue&type=script&lang=js"
export * from "./EditPopover.vue?vue&type=script&lang=js"
import style0 from "./EditPopover.vue?vue&type=style&index=0&id=f0689786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0689786",
  null
  
)

export default component.exports